<template>
    <div class="bg-white py-3 px-8" data-cy="container_home_member_code">
        <div class="flex items-start py-3">
            <div>
                <div class="font-bold text-16 text-a-black-3b3b3b">
                    {{lbl.home.member_code.fill_code}}
                </div>
                <div class="text-12 text-a-gray-666666 pt-1 pb-4">
                    {{lbl.home.member_code.fill_time}} {{displayTime}} {{lbl.home.member_code.txt_minute}}
                </div>
                <div>
                    <InputCode
                        data-cy="input_home_member_code"
                        v-model:inputValue="memberCode"
                        :isTextOnly="true"
                        :errorInfo="errorInfo[0]"
                        :isSubmitted="isSubmitted"
                        :inputLbl="lbl.home.member_code.code" />
                </div>
            </div>
            <div class="ml-auto">
                <img :src="getFlagIcon()" alt="BBL flag1" data-cy="img_home_member_code_flag" />
            </div>
        </div>
        <div class="w-full pt-2">
            <GrayButton v-if="isDisabled" data-cy="btn_home_member_code_confirm_disabled">{{lbl.home.member_code.btn_confirm}}</GrayButton>
            <button v-else class="w-full bg-a-blue-0064ff text-16 text-white font-bold rounded-lg py-2.5 px-3"
                data-cy="btn_home_member_code_confirm"
                @click="onSubmitCode()">
                {{lbl.home.member_code.btn_confirm}}
            </button>
        </div>
    </div>
</template>
<script>

//mixin
import LocaleMixin from '@/mixin/LocaleMixin.js';
import ModalMixin from '@/mixin/ModalMixin.js';
import ErrorApiMixin from '@/mixin/ErrorApiMixin.js';
//helper
import Account from '@/helper/AccountHelper.js';
import ConfigManager from '@/config/ConfigManager.js';
import { FormHelper } from '@/helper/FormHelper.js';
import DatetimeHelper from '@/helper/DatetimeHelper.js';
import TimerHelper from '@/helper/TimerHelper.js';
//import Util from '@/helper/Utility.js';
//component
import InputCode from '../component/InputCode.vue';
import GrayButton from '@/components/Button/GrayButton.vue'
//service
import HomeService from '../service/HomeService.js';
import BzbsAuth from '@/core/Account/service/BzbsAuth.js';
import { AccountModel } from "@/core/Account/model/AccountModel.js";

export default {
    name: 'MemberCode',
    mixins: [LocaleMixin, ModalMixin, ErrorApiMixin],
    components: {
        InputCode,
        GrayButton
    },
    data: function(){
        return {
            memberCode: null,
            timer: new TimerHelper(),

            isSubmitted: false,

            errorInfo: FormHelper.genErrorInfo(1),
            displayTime: '',
            isTimeExpired: false,
            isDisabled: false
        }
    },
    created: function(){
        this.getTime();
    },
    methods: {
        getTime: function(){
            //let time_diff2 = DatetimeHelper.getTimeDiffToday();
            let endDate = new Date().setHours(23,59,59,999);
                endDate = new Date(endDate);

            let joinDate = Account.getUserJoinDate();
                joinDate = DatetimeHelper.unixTimestampToDate(joinDate);

            let currentDate = new Date();
                //currentDate = DatetimeHelper.unixTimestampToDate(currentDate);

            let time_diff = DatetimeHelper.calDiffInHour(joinDate, endDate);
            let currentTime_diff = DatetimeHelper.calDiffInHour(currentDate, endDate);
            console.log('currentDate', currentDate);
            console.log('endDate', endDate);
            console.log('time', time_diff);
            console.log('currentTime_diff', currentTime_diff);

            if(time_diff != null){

                if(time_diff <= 0){
                    this.isTimeExpired = true;
                    this.timeExpired();
                }else{
                    this.timer.initialTimer(currentTime_diff * 60 * 60, ':', true, false);
                    this.timer.stopTimer();
                    this.timer.resetTimer();

                    this.timer.runTimer((display) => {
                        this.displayTime = display;
                    }, () => {
                        console.log('time out');
                    });
                }


            }
        },
        timeExpired: function () {
            this.$emit("onTimeExpired");
        },
        onSubmitCode: async function(){
            this.tracking.event('home_flag1_confirm', 'click_flag1', null, null);

            this.isDisabled = true;
            this.modal.loadingModal.show();
            let res = await this.apiSubmitCode();
            this.modal.loadingModal.hide();

            if(!res) return;

            let title = '';
            let message = '';
            let btn = this.lbl.modal.btn;
            let isCampaign = false;

            if((res.data.point == null || res.data.point == 0) && res.data.redeem == null){
                title = this.lbl.modal.register.title;
                message = this.lbl.modal.register.msg;
            }else{
                if(res.data.point != null && res.data.point != 0){
                    title = this.lbl.modal.point.title;

                    if(res.data.codeType == 'referral'){
                        title = this.lbl.modal.point.title_fgf;
                    }
                    message = this.FilterStringFormat(this.lbl.modal.point.msg, res.data.point);
                }else{
                    if(res.data.redeem){
                        title = this.lbl.modal.redeemed.title;
                        message = res.data.redeem.Name;
                        btn = this.lbl.modal.redeemed.btn;

                        isCampaign = true;
                    }
                }
            }

            this.modal.alertModal
                .clearModal()
                .setTitle(title)
                .setMsg(message)
                .setBtnOk(btn)
                .show();

            this.modal.alertModal.onShow(() =>{
                this.tracking.screenName('Popup_flag1');
                this.tracking.event('Popup_flag1', 'view_Popup_flag1', null, null);
            });

            this.modal.alertModal.onClickOk(async () =>{
                this.tracking.event('Popup_flag1', 'click_Popup_flag1', null, null);

                this.modal.loadingModal.show();
                await this.reLoginDevice();
                this.modal.loadingModal.hide();

                if(isCampaign){
                    this.$router.push('/history');
                }else{
                    window.location.reload();
                }
            });
        },
        apiSubmitCode: function(){
            return new Promise((resolve) => {
                HomeService.submitCodeFlag1(this.memberCode)
                    .subscribe({
                        next: (res) => {
                            console.log('res', res)
                            resolve(res);
                        },
                        error: (err) => {
                            console.log(err);
                            let alertTitle = '';
                            let alertMsg = '';

                            if(err.code == 404 || err.code == 2021 || err.code == 409 || err.code == 400 || err.code == 3002 || err.code == 1407){
                                alertTitle = this.lbl.home.error_code[err.code].title;
                                alertMsg = this.lbl.home.error_code[err.code].msg;

                                this.modal.errorModal
                                    .clearModal()
                                    .setTitle(alertTitle)
                                    .setMsg(alertMsg)
                                    .show()

                                this.modal.errorModal.onClickOk(() =>{
                                    window.location.reload();
                                });

                            }else{
                                this.errorApi(err);
                            }

                            resolve(null);
                        }
                    });
            });
        },
        reLoginDevice: async function() {
            return new Promise((resolve) => {
                var token = Account.getToken();
                var uuid = Account.getUUID();
                BzbsAuth.apiReLoginDevice(token, uuid)
                    .subscribe({
                        next: (data) => {
                            console.log('resume', data);
                            let accountModel = new AccountModel();
                            accountModel.loadCache()
                            accountModel.token = data.token
                            accountModel.userLevel = data.userLevel
                            accountModel.userFlags = data.userFlags
                            accountModel.userLevelDetail = data.userLevelDetail
                            // accountModel.setDataFromApi(data)
                            accountModel.saveCache();
                            resolve(accountModel);
                        },
                        error: (err) => {
                            console.log(err);
                            this.errorApi(err);
                            resolve(null);
                        }
                    });
            });
        },
        getFlagIcon: function() {
            var appId = ConfigManager.getAppId();
            return ConfigManager.getBlobUrl()+ `/webconfig/${appId}/images/icons/ic-flag1-new.svg`;
        },
    }
}
</script>
 <style lang="scss" scoped>
.bg-member-code{
    width: 100%;
    height: 150px;
    background-image: url('../../../assets/bg/bg-member-code@3x.png');
    background-repeat: no-repeat;
    background-position: top center;
    background-size: 100%;

    .bg-quote{
        width: 275px;
        height: 60px;
        background-image: url('../../../assets/bg/bg-quote.png');
        background-repeat: no-repeat;
        background-position: top center;
        background-size: 100%;
    }
}
 </style>
